import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { DisqualifyProposalValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/schemas/disqualifyProposal.schema';

interface UseMaintenanceEstablishmentChoiceAuctionEntryProposalsDisqualifyProps {
  proposalId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    DisqualifyProposalValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryProposalsDisqualify = ({
  proposalId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryProposalsDisqualifyProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceAuctionEntryProposalsDisqualify'],
    mutationFn: (form) => {
      const payload = {
        reason: form.reason,
      }

      return privateAxios.put(`/maintenance/establishment_choice/auction_entry_proposals/${proposalId}/disqualify`, {
        auction_entry_proposal: payload,
      });
    },
    ...options
  });
}
